import { useDesktopNavigation } from '@components/navbar/desktop/DesktopNavigationContext'
import { AdminIcon } from '@components/navbar/icons'
import useTypedTranslation from '@hooks/useTypedTranslation'
import { routesFactory } from '@utils/routes.ts'

import NavItem from './NavItem'

function AdminNavItem() {
  const { t } = useTypedTranslation()
  const { user, isActive } = useDesktopNavigation()

  if (!user.isAdmin) return null

  return (
    <NavItem
      to={routesFactory.administration()}
      label={t('admin.title')}
      isActive={isActive('administration')}
      icon={<AdminIcon size={20}/>}
    />
  )
}

export default AdminNavItem

